import {z} from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {tradeDbSchema} from './tradeDbSchema';
import {tradeMessageSchema} from './tradeMessageSchema';

export const tradeSchema = tradeDbSchema
  .omit({
    openedAt: true,
    closedAt: true,
    createdAt: true,
    messages: true,
  })
  .extend({
    id: z.string(),
    openedAt: firestoreTimestampToDateSchema,
    closedAt: firestoreTimestampToDateSchema.optional(),
    createdAt: firestoreTimestampToDateSchema,
    messages: tradeMessageSchema.array().default([]),
  });

export type Trade = z.infer<typeof tradeSchema>;
